<template>
    <div class="BusinessDetail">
        <HeaderBusinessDetail />
        <BusinessGeneralDetails />
    </div>
</template>

<script>
  import { Card } from '@/components';

  import HeaderBusinessDetail from './HeaderBusinessDetail.vue';
  import BusinessGeneralDetails from './BusinessGeneralDetails.vue';

  export default {
    name: 'BusinessDetail',
    components: {
      Card,
      HeaderBusinessDetail,
      BusinessGeneralDetails,
    },
  };
</script>
<style lang="scss">
    .BusinessDetail {
        width: 100%;
        height: 100%;
        &__Details {
            .Name_Sector {
                .Card {
                    width: rem(250);
                    height: rem(100);
                    margin: rem(10);
                }
                display: flex;
                justify-content: center;
            }
            .List {
                width: 60%;
                .Detail {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: rem(1px) solid $white-700;
                    margin-top: rem(10);
                    p {
                        padding: rem(25);
                    }
                }
            }
        }
    }
</style>
